import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, premiumRequired = false, openModal }) => {
  const { isLoggedIn, isPremiumUser, isLoading } = useAuth();

  // Show loading while checking auth
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Trigger login modal if not logged in
  if (!isLoggedIn) {
    openModal(); // Open the login modal
    return null; // Don’t render anything until login
  }

  // Redirect if premium is required but user isn’t premium
  if (premiumRequired && !isPremiumUser) {
    return <Navigate to="/premium" />;
  }

  // Render the protected content
  return children;
};

export default ProtectedRoute;